<div class="date__picker-container">
  <label for="date-picker">{{label()}}</label>
  <button type="button" class="date__picker-input" (click)="openDatePickerModal()" tabindex="0">
    <input
      type="text"
      readonly="true"
      [formControl]="control"
      [value]="'1 Januari 2025'"
      [placeholder]="placeholder()"
    />
    <img src="assets/icons/ico_calendar.svg" alt="">
  </button>
</div>